import './machineApp.css';
import { setEnvironment } from '@vse/environment';
import { standalone } from '@vse/main';

export function initializeMachineApp (library, navigate) {
  setEnvironment('pendant', 'machineapp');

  const machineAppContainer = $("<div id='main' class='h_layout spaced ui_builder_page'>");
  const leftPane = $("<div id='left_pane' class='v_layout'>");
  const rightPane = $("<div id='right_pane' class='v_layout'>");

  $('#guiContainer')
    .addClass('v_layout spaced')
    .append(
      machineAppContainer.append(
        leftPane,
        rightPane,
      ),
    );

  standalone(library, navigate);
}
